export default __webpack_public_path__ + "static/media/not_found.3cf508f7.jpg";